import { TEAM_HEALTH_PAGE } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const teamHealthRoute = createSiteRoute({
  exact: true,
  name: TEAM_HEALTH_PAGE,
  path: '/team/health/:teamId?',
});
